// extracted by mini-css-extract-plugin
export default {"myTable":"Scorer_myTable__9dSqK","mythic":"Scorer_mythic__yloAg","ultra":"Scorer_ultra__NRSiD","super":"Scorer_super__mzMr8","petal":"Scorer_petal__mDywC"};